module.exports = __webpack_public_path__ + "static/img/200130.8c8a3229.png";